import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import SectionHeading from './UI/SectionHeading';

const reviews = [
  {
    id: 1,
    author: "Elena R.",
    location: "Patagonia, Chile",
    text: "Survived 3 weeks of unpredictable weather and constant movement. The compression cubes are basically magic. My pack remained organized despite the chaos outside.",
    rating: 5,
    date: "Oct 2023"
  },
  {
    id: 2,
    author: "Marcus T.",
    location: "Tokyo, Japan",
    text: "The tech folio alone is worth the investment. Navigating airport security and cramped train cabins was effortless when everything had its exact place.",
    rating: 5,
    date: "Dec 2023"
  },
  {
    id: 3,
    author: "Sarah L.",
    location: "Marrakech, Morocco",
    text: "Replaced a graveyard of cheap packing cubes with the Nomad set. The material feel, the zippers, the logic behind the sizing—it's evident this was designed by actual travelers.",
    rating: 5,
    date: "Jan 2024"
  }
];

const Reviews = () => {
  return (
    <section id="journal" className="py-32 max-w-7xl mx-auto px-6">
      <SectionHeading 
        badge="Field Reports"
        title="Dispatches."
        subtitle="Verified accounts from explorers who have deployed NomadCrate systems in the most demanding environments."
      />

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
        {reviews.map((review, index) => (
          <motion.div 
            key={review.id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="journal-border p-10 bg-white/40 hover:bg-white/90 transition-all duration-500 relative group hover:-translate-y-2 shadow-sm hover:shadow-xl"
          >
            <div className="absolute top-8 right-8 flex gap-1 text-amber">
              {[...Array(review.rating)].map((_, i) => (
                <SafeIcon key={i} icon={FiIcons.FiStar} className="fill-current text-xs" />
              ))}
            </div>
            
            <p className="text-ink text-xl mb-10 relative z-10 font-serif italic leading-relaxed">
              "{review.text}"
            </p>
            
            <div className="mt-auto pt-8 border-t border-dashed border-cobalt/20">
              <div className="flex justify-between items-end">
                <div>
                  <p className="font-black text-[10px] uppercase tracking-[0.3em] text-cobalt mb-1">{review.author}</p>
                  <p className="text-xs text-ink-light/60 flex items-center gap-2">
                    <SafeIcon icon={FiIcons.FiMapPin} className="text-amber" />
                    {review.location}
                  </p>
                </div>
                <span className="text-[10px] font-mono text-ink-light/30">{review.date}</span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Reviews;